/* eslint-disable import/no-extraneous-dependencies */
import React, { Suspense, lazy } from 'react';
import PropTypes from 'prop-types';
import AuthorBoxComponent from 'gatsby-core-theme/src/components/atoms/author-box';
import NotFound from 'gatsby-core-theme/src/components/atoms/not-found';
import Module from '~molecules/module';
import styles from './main.module.scss';
import keygen from '~helpers/keygen';
import { getExtraField } from '~helpers/getters';
import { isSearchPath } from '~helpers/isSearchPath';
import Search from '~pages/search';

const Main = ({
  section = {},
  pageContext = {},
  serverData = {},
  exclOperator = false,
  showAuthorBox = false,
  showAuthor = true,
}) => {
  const { page, allMarkets } = pageContext;

  const AuthorBox = page.author_id;
  const HtmlSitemap = pageContext.sitemapData
    ? lazy(() => import(`gatsby-core-theme/src/components/atoms/sitemap`))
    : null;

  const isContactUsPage = !!section?.modules?.filter((module) => module.name === 'contact_form')
    .length;
  const EEAT = process.env.GATSBY_SITE_NAME === 'casinocapitan.com';
  const pathPrefixes = isSearchPath(allMarkets, page.path);
  const ReviewCredits =
    page.path !== '/' &&
    !isContactUsPage &&
    page.path !== 'news' &&
    page.path !== 'sitemap' &&
    page.template !== 'ppc' &&
    page.author_id &&
    showAuthor
      ? lazy(() => import('../../../../components/atoms/review-credits'))
      : null;

  const date =
    page.manual_updated_date || page.manual_published_date
      ? page.manual_updated_date || page.manual_published_date
      : '';

  const color = getExtraField(page.extra_fields, 'main_background_color');
  const moduleTitleColor = getExtraField(page.extra_fields, 'module_title_color');
  const ctaColor = getExtraField(page.extra_fields, 'cta_color');
  const colorCtaTxt = getExtraField(page.extra_fields, 'color_txt_cta');

  return (
    <>
      <main
        className={styles.mainContent || ''}
        style={{
          backgroundColor: color,
          '--heading-base-color': moduleTitleColor || ``,
          '--primary-button-color': ctaColor || ``,
          '--hover-button-color': ctaColor || ``,
          '--primary-button-color-text': colorCtaTxt || ``,
        }}
      >
        {page.path.includes('404') && <NotFound pageContext={pageContext} />}
        {HtmlSitemap && (
          <Suspense fallback={<></>}>
            <HtmlSitemap pageContext={pageContext} />
          </Suspense>
        )}
        {EEAT && ReviewCredits && (
          <Suspense fallback={<></>}>
            <ReviewCredits
              date={date}
              authors={page?.allAuthors ? page?.allAuthors : page?.author_id && [page?.author]}
              readingTime={page.reading_time}
              reviewer={page.reviewer_id && page?.reviewer}
              hasAuthorBox={Boolean(AuthorBox)}
              type={page?.template}
            />
          </Suspense>
        )}
        {section &&
          section.modules &&
          section.modules.map((module, index) => (
            <Module
              key={keygen()}
              module={module}
              exclOperator={exclOperator}
              page={page}
              pageContext={pageContext}
              serverData={serverData}
              modulePosition={index + 1}
            />
          ))}
        {pathPrefixes && (
          <Search page={page} serverData={serverData} allMarkets={pageContext.allMarkets} />
        )}
        {AuthorBox && showAuthorBox && (
          <Suspense fallback={<></>}>
            <AuthorBoxComponent
              author={page.author}
              date={page.updated_at ? page.updated_at : page.created_at}
              readingTime={page.reading_time}
              reviewer={page.reviewer_id && page.reviewer}
            />
          </Suspense>
        )}
      </main>
    </>
  );
};

Main.propTypes = {
  section: PropTypes.shape({
    modules: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
      })
    ),
  }),
  page: PropTypes.shape({
    path: PropTypes.string,
  }),
  pageContext: PropTypes.shape({}),
  serverData: PropTypes.shape({}),
  exclOperator: PropTypes.bool,
  showAuthor: PropTypes.bool,
  showAuthorBox: PropTypes.bool,
};

export default Main;
